import * as wording from '../wording.ts';
import type { BoardCard } from './model.ts';

/**
 * Which selected cards the content-status bulk actions apply to (US-028,
 * rejected-status US-007): why a card is left out, or `null` when it
 * qualifies. Imports nothing but the wording, so the server's test run can
 * load it as it is.
 */

/** **Mark posted**: a delivered content not posted yet; a rejected one cannot be posted. */
export function skipMarkPosted(card: BoardCard): string | null {
  if (card.type === 'content' && card.content.status === 'rejected') return wording.BULK_SKIP_REJECTED;
  if (card.type !== 'content' || card.content.status !== 'delivered') return wording.BULK_SKIP_NOT_DELIVERED;
  return card.content.briefDetails.placed ? wording.BULK_SKIP_PLACED : null;
}

/** **Reject…**: a delivered content. */
export function skipReject(card: BoardCard): string | null {
  return card.type === 'content' && card.content.status === 'delivered' ? null : wording.BULK_SKIP_NOT_DELIVERED;
}

/** **Un-reject**: a rejected content. */
export function skipUnreject(card: BoardCard): string | null {
  return card.type === 'content' && card.content.status === 'rejected' ? null : wording.BULK_SKIP_NOT_REJECTED;
}
